module.exports = __webpack_public_path__ + "img/Ilustracion_1.e0efa86d.png";